export default "__VITE_ASSET__CNBIW$3z__"